import createAPIRequestId from '../helpers/createAPIRequestId'
import hasTempId from '../helpers/hasTempId'
import store from '../store/index'
//----------------------
// edit character item
//----------------------
export default async function useEditCharacterItem(item, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditCharacterItem....')
  console.log('item:', item)
  //--------------
  // access store
  //--------------
  const this_store = store
  //--------------------
  // set api call parms
  //--------------------
  let parm_id = ''
  let parm_partialInd = false
  const hasPersistedId =
    item.id !== undefined && item.id !== null && item.id !== '' && !hasTempId(item.id)

  if (hasPersistedId) {
    parm_id = item.id
    parm_partialInd = item.action !== 'DELETE' ? true : false
  }
  //---------------------------------------------
  // declare request parms to create api request
  //--------------------------------------------
  let endpoint = 'api/v1/character-items/'
  //
  let request_parms = {
    endpoint: preview ? endpoint + '?preview=true' : endpoint,
    partialInd: parm_partialInd,
    id: parm_id,
  }
  //---------------------------------------------------
  // where DELETE add indicator for create api request
  //---------------------------------------------------
  if (item.action === 'DELETE') {
    request_parms.deleteInd = true
  }
  //--------------------------
  // create api request by id
  //--------------------------
  let request = createAPIRequestId(request_parms)
  console.log('[RECOVERABLE_ARTEFACT_TRACE] useEditCharacterItem request', {
    action: item?.action ?? null,
    raw_id: item?.id ?? null,
    has_persisted_id: hasPersistedId,
    method: request?.method ?? null,
    endpoint: request?.endpoint ?? null,
    payload_item: item?.payload?.item ?? null,
    payload_character: item?.payload?.character ?? null,
  })
  //---------------
  // set api parms
  //---------------
  let api_parms = {
    api_request: request,
    api_preview: preview,
  }
  //----------------------------------
  // include payload where provided
  //----------------------------------
  if (item.payload) {
    api_parms.payload = item.payload
  }
  console.log('api_parms = ', api_parms)
  //-------------------------------------------------------------------------
  // - return the dispatch Promise in all cases
  // - preview callers will await this and receive the response
  // - non-preview callers can ignore the returned Promise (fire-and-forget)
  //-------------------------------------------------------------------------
  return this_store
    .dispatch('characters/editCharacterItem', api_parms)
    .then((res) => {
      // optional: log preview response
      if (preview) console.log('useEditCharacterItem preview result:', res)
      return res
    })
    .catch((err) => {
      if (err?.response?.status === 404 && item.action === 'DELETE') {
        console.warn(
          'CharacterItem already deleted; treating DELETE as successful for item =',
          item.name,
        )

        return {
          data: null,
          status: 204,
          statusText: 'No Content',
        }
      }

      console.error('editCharacterItem error:', err)
      // rethrow so callers awaiting this will receive the rejection
      throw err
    })
}
